<template>
	<!-- 车辆管理 -->
	<div class="public_Spacing carManagement">
		<div class="pulbic_oparetionBlock">


			<div class="public_criteriaRange">

				<div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">企业：</label>
					<el-select class="public_optionSty dropDown_Define" @change="erpChange" v-model="enterpriseTwo"
						filterable remote :remote-method="filterEnterprise" placeholder="请选择">
						<el-option v-for="item in filteredEnterpriseOptions" :key="item.SETTB99ID"
							:label="item.SETTB99CA00" :value="item.SETTB99ID">
						</el-option>
					</el-select>
				</div>
				<div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">物料：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="materielMo" placeholder="请选择"
						filterable :disabled="!enterpriseTwo"
						@focus="!enterpriseTwo && $message.warning('请先选择企业')">
						<el-option v-for="item in materielOptions" :key="item.SETTB109ID" :label="item.SETTB109CA00"
							:value="item.SETTB109ID">
						</el-option>
					</el-select>
				</div>
				<div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">状态：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="status" placeholder="请选择">
						<el-option v-for="item in dataStatusOperation" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
				<div class="public_oparetionBlock_Menu public_operatBtn">
					<button @click="queryClick" class="public_saleWater_chaxun pulic_cursor" v-shiroHiden="solelist"
						id="查询"><i class="iconfont icon-chaxun"></i>查询</button>
				</div>
			</div>
			<!-- <div class="public_operatArea">
				<div class="public_operatBtn" style="margin-left: 0;">
					<button @click="queryClick" class="public_saleWater_chaxun pulic_cursor" v-shiroHiden="solelist"
						id="查询"><i class="iconfont icon-chaxun"></i>查询</button>
					<button @click="newlyAdd" class="public_saleWater_xinzeng pulic_cursor" v-shiroHiden="solelist"
						id="新增"><i class="iconfont icon-tianjia1"></i>新增</button>
				</div>
			</div> -->
		</div>
		<div class="bcarManagement-table pulbic_table_container">
			<el-table :data="tableData" style="width: 100%;" max-height="90%" stripe
				:default-sort="{prop: 'waterNum', order: 'descending'}"
				:header-cell-style="{color:'rgba(51,51,51,1)','font-weight':'bold'}" class="public_tableColumn">
				<el-table-column label="厂家" prop="SETTB99CA00">
				</el-table-column>
				<el-table-column label="厂家物料名称" prop="SETTB109CA00">
				</el-table-column>
				<el-table-column label="归类物料名称" prop="SETTB206CA01">
				</el-table-column>
				<el-table-column label="状态" prop="STATUS">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.STATUS=='未归类'" type="danger">
							{{scope.row.STATUS}}
						</el-tag>
						<el-tag v-if="scope.row.STATUS=='已归类'" type="success">
							{{scope.row.STATUS}}
						</el-tag>
					
					</template>
					
					
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button @click="wllbmodify(scope.row)"
							class="public_icon_xiugai public_icon_width  public_icon_margin" v-shiroHiden="solelist"
							id="修改" type="primary" size="small">归类</el-button>
						<!-- <el-button v-shiroHiden="solelist" id="删除" @click="deleteClick(scope.row)"
							class="public_icon_jinyong public_icon_width" type="primary" size="small">删除</el-button> -->
					</template>
				</el-table-column>
			</el-table>
			<div class="pulbic_pagesize">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="limitMo"
					layout="total,sizes, prev, pager, next, jumper" :total="pagingPageMo">
				</el-pagination>
			</div>
		</div>

		<!-- 新增 -->
		<div class="public-dialog">
			<el-dialog title="新增车辆信息" @close="XAdd" :visible.sync="billOperationAdd" width="30%"
				:closeOnClickModal='false' append-to-body custom-class="system-settings-systemwl-admin-dialog">
				<div class="systemCodePC-add-code">
					<div class="systemCodePC-add-code-table">
						<div class="systemCodePC-add-code-table-li">
							<div class="systemCodePC-add-code-table-li-name">车牌号</div>
							<div class="systemCodePC-add-code-table-li-ipt">
								<input type="text" class="car-number-add" @input="numinput" :maxlength="maxl"
									v-model="carNumberAdd" />
							</div>
							<div class="systemCodePC-add-code-table-li-text">*必填*</div>
						</div>
						<div class="systemCodePC-add-code-table-li">
							<div class="systemCodePC-add-code-table-li-name">车主姓名</div>
							<div class="systemCodePC-add-code-table-li-ipt">
								<input type="text" v-model="carNameAdd" />
							</div>
							<div class="systemCodePC-add-code-table-li-text"></div>
						</div>
						<div class="systemCodePC-add-code-table-li">
							<div class="systemCodePC-add-code-table-li-name">车主电话</div>
							<div class="systemCodePC-add-code-table-li-ipt">
								<input maxlength="11" type="text" v-model="carPhoneAdd"
									v-on:input="carPhoneAdd=carPhoneAdd.replace(/[^\d]/g,'')" />
							</div>
							<div class="systemCodePC-add-code-table-li-text"></div>
						</div>
						<div class="systemCodePC-add-code-table-li">
							<div class="systemCodePC-add-code-table-li-name">皮重</div>
							<div class="systemCodePC-add-code-table-li-ipt">
								<input type="text" v-model="tareIptAdd" @keyup="tareIptAddUP" />
							</div>
							<div class="systemCodePC-add-code-table-li-text"></div>
						</div>
					</div>
					<div class="systemCodePC-add-code-btn">
						<el-button type="warning" @click="cancelAdd">取消</el-button>
						<el-button type="primary" @click="preservationAdd">保存</el-button>
					</div>
				</div>
			</el-dialog>
		</div>
		<!-- 修改 -->
		<div class="public-dialog">
			<el-dialog title="物料归类" @close="XAdd" :visible.sync="billOperationDetails" width="30%"
				:closeOnClickModal='false' append-to-body custom-class="system-settings-systemwl-admin-dialog">
				<div class="systemCodePC-add-code">
					<div class="systemCodePC-add-code-table">
						<div class="systemCodePC-add-code-table-li">
							<div class="systemCodePC-add-code-table-li-name">厂家物料名称</div>
							<div class="systemCodePC-add-code-table-li-ipt">
								<input type="text" disabled="disabled" class="car-number-add" v-model="wlnameobj.SETTB109CA00" />
							</div>
							<div class="systemCodePC-add-code-table-li-text">*必填*</div>
						</div>
						<div class="systemCodePC-add-code-table-li">
							<div class="systemCodePC-add-code-table-li-name">更改类型</div>
							<div class="systemCodePC-add-code-table-li-ipt">
								<el-select v-model="carNameModify" @change="selChangName" placeholder="请选择">
									<el-option v-for="item in customerManagementList" :key="item.SETTB206CA00"
										:label="item.SETTB206CA01" :value="item.SETTB206CA00">
									</el-option>
								</el-select>
								<!-- <input type="text" v-model="carNameModify" /> -->
							</div>
							<div class="systemCodePC-add-code-table-li-text"></div>
						</div>

					</div>
					<div class="systemCodePC-add-code-btn">
						<el-button type="warning" @click="cancelModify">取消</el-button>
						<el-button type="primary" @click="preservationModify">保存</el-button>
					</div>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
import enterpriseSearchMixin from '@/mixins/enterpriseSearchMixin'
	export default {
  mixins: [enterpriseSearchMixin],
		data() {
			return {
				userobj: this.$store.state.uobj, //登陆缓存--用户信息
				carNum: "",
				billOperationAdd: false,
				billOperationDetails: false,
				tableData: [],
				customerManagementList: [],
				customerManagementPhoneList: [],
				enterpriseTwoOptionList: [{
					SETTB109CA00: '全部',
					SETTB109ID: '',
				}], //二级企业下拉框--新增
				enterpriseTwo: '', //二级企业

				materielMo: '',
				materielOptions: [{
					SETTB109CA00: '全部',
					SETTB109ID: '',
				}],
      filteredEnterpriseOptions: [],
				// 状态
				dataStatusOperation: [{
						value: '',
						label: '全部',
					}, {
						value: '0',
						label: '未归类',
					},
					{
						value: '1',
						label: '已归类',
					}
				],
				status: '', //数据状态

				// 新增
				carNumberAdd: '',
				carNameAdd: '',
				carPhoneAdd: '',
				tareIptAdd: '',
				judgeAdd: 0, //判断校验车辆，车辆类型是新增还是修改--新增
				maxl: '',
				// 修改


				wlnameobj: {

				},
				carNumberModify: '',
				carNameModify: '',
				carPhoneModify: '',
				tareIptModify: '',
				edCarNameModify: '',
				edCarPhoneModify: '',
				carID: '', //一二级客户车辆id
				judgeModify: 1, //判断校验车辆，车辆类型是新增还是修改--修改
				judgeCarNumMo: '', //判断修改时当前输入的车牌号是否和未修改之前的一样--修改
				pageMo: 1, //默认列表页码
				limitMo: 10, //每页的条数
				pagingPageMo: 0, //分页--数据列表共有的条数
				currentPage: 1, //设置当前页默认为1
				// 历史缓存
				currentUrl: this.$route.path,
				historyInfo: '',

				solelist: [],
			}
		},
		created() {
			var list = "";
			list = this.$store.state.solelist;
			var path = this.$route.path;
			this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
			this.userobj = this.$store.state.uobj;
			// 赋值，缓存销毁
			this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
			sessionStorage.removeItem(this.currentUrl)
			if (this.historyInfo != null && this.historyInfo != '') {
				this.init()
			}

		},
		watch: {
			// 车牌号--查询
			carNum: function(val) {
				this.carNum = val.toUpperCase()
			},
			// 车牌号--新增
			carNumberAdd: function(val) {
				this.carNumberAdd = val.toUpperCase()
			},


		},
		mounted() {
			this.pageList();
			this.loadEnterpriseOptions()
		},
		// 存储数据
		beforeDestroy() {
			var obj = {
				carNum: this.carNum, //车牌号
				currentPage: this.currentPage, //当前页数
				pageMo: this.pageMo, //页码
				limitMo: this.limitMo //每页条数
			}
			sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
		},
		methods: {
			loadEnterpriseOptions() {
				var postData = {
					ORMTB400ID: this.userobj.ormtb400.ORMTB400ID,
					type: 1
				}
				var List = [{ SETTB99ID: '', SETTB99CA00: '全部' }]
				this.axios.post('/set/settb100/selectSettb100ByCa02', postData).then(res => {
					if (res.data.code == 200) {
						this.enterpriseTwoOptionList = [...List, ...res.data.data]
						this.filteredEnterpriseOptions = this.enterpriseTwoOptionList.slice(0, 100)
					} else {
						this.$message({ message: res.data.message, type: 'error' })
					}
				})
			},

			//初始化数据
			init() {
				this.carNum = this.historyInfo.carNum
				this.currentPage = this.historyInfo.currentPage
				this.pageMo = this.historyInfo.pageMo
				this.limitMo = this.historyInfo.limitMo
			},


			materielMoPost() {
				var i = (this.enterpriseTwoOptionList || []).findIndex((profile) => profile.SETTB99ID === this
					.enterpriseTwo);
				var url = "/set/settb109/selectPageList";
				var SETTB100ID = this.enterpriseTwoOptionList[i].SETTB100ID
				var data = {
					SETTB109CA03: '',
					SETTB109CA00: '',
					SETTB109CD01: SETTB100ID,
					SETTB99ID: this.enterpriseTwo,
					page: 1,
					limit: 1000,
				};
				var List = [{
					SETTB109CA00: '全部',
					SETTB109ID: '',
				}];
				this.axios.post(url, data).then(res => {
					if (res.data.code == 200) {
						this.materielOptions = [...List, ...res.data.data];
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				})
			},
			erpChange() {
				if (this.enterpriseTwo != '') {
					this.materielMoPost()
				} else {
					this.materielMo = ''
					this.materielOptions = [{
						SETTB109CA00: '全部',
						SETTB109ID: '',
					}]
				}
			},
			selChangName(e) {
				
				// console.log(this.carNameModify)
			},
			// 导出
			exports() {
				var SETTB402CA00 = this.carNum; //车牌号
				var url = this.axios.defaults.baseURL + "/set/settb402/toExcel?SETTB402CA00=" + SETTB402CA00;
				window.location.href = url;
			},
			// 删除
			deleteClick(row) {
				var postData = {
					sign: this.userobj.pertb005.pertb005cb00,
					carID: row['carID'],
					SETTB402ID: row['carNumID'],
				}
				var url = "/set/settb402/delete";
				this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.axios.post(url, postData).then(res => {
						// console.log(res)
						if (res.data.code == 200) {
							this.pageList()
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
						} else {
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
					})
				})
			},
			numinput() {
				this.carNumberAdd = this.checkNum(this.carNumberAdd)
			},
			checkNum(item) {
				var regNum = /^[0-9]+$/
				var regALP = /^[0-9A-Z]+$/
				var regJane = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领]+$/
				var item = item.trim()
				item = item.toUpperCase()
				var regCar = /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][0-9]{1})$/
				var numarr = item.split('')
				var j, str, isnum
				for (var i = 0; i < numarr.length; i++) {
					if (i == 0) {
						if (!regJane.test(numarr[i])) return item = item.slice(0, 0)
					} else if (i >= 1) {
						if (i == 1) {
							if (!regALP.test(numarr[i])) return item = item.slice(0, item.length - 1)
							str = item.slice(0, 2)
							if (regCar.test(str)) {
								this.maxl = 8
								isnum = true
							} else {
								this.maxl = 7
								isnum = false
								item = item.slice(0, 7)
							}
						} else {
							if (isnum == true) {
								if (i == 2) {
									if (!regNum.test(numarr[i])) return item = item.replace((numarr[i]), "")
								}
							}
							if (!regALP.test(numarr[i])) return item = item.slice(0, item.length - 1)
						}
					}
				}
				return item
			},
			// 新增保存
			preservationAdd() {
				var regC =
					/^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领])|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][0-9]{2}([0-9]|[A-Z]){5}))$/;
				var regP = /^1[3-9][0-9]{9}$/;
				if (!regC.test(this.carNumberAdd)) {
					this.$message({
						message: '车牌号格式不正确，请检查!',
						type: 'error'
					});
				} else if (this.carPhoneAdd != '' && !regP.test(this.carPhoneAdd)) {
					this.$message({
						message: '手机号格式不正确，请检查!',
						type: 'error'
					})
				} else {
					// this.checkCarNumber(this.carNumberAdd, this.judgeAdd);
					this.postAdd()
				}
			},
			// 新增调用接口
			postAdd() {
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				if (this.userobj.pertb005.pertb005cb00 == 'CUS-1') {
					var ORMTB400ID = this.userobj.ormtb400.ORMTB400ID
				} else if (this.userobj.pertb005.pertb005cb00 == 'CUS-2') {
					var ORMTB400ID = this.userobj.ormtb410.ORMTB410ID
				}
				var postData = {
					SETTB402CA00: this.carNumberAdd, //车牌号
					SETTB402CA01: this.carNameAdd, //车主姓名
					SETTB402CA02: this.carPhoneAdd, //车主电话
					sign: this.userobj.pertb005.pertb005cb00,
					personID: ORMTB400ID, //一二级客户id
					SETTB402CA03: this.tareIptAdd, //皮重
				}
				var url = "/set/settb402/insert";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						if (res.data.message == '车牌号已存在,不能重复添加!') {
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						} else {
							this.billOperationAdd = false;
							this.$message({
								message: '新增成功',
								type: 'success'
							});
							this.pageList();
						}

					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close();
				})
			},
			tareIptAddUP() { //限制验证码长度
				var value = this.tareIptAdd;
				this.tareIptAdd = this.clearNoNum(value);
			},
			tareIptModifyUP() {
				var value = this.tareIptModify;
				this.tareIptModify = this.clearNoNum(value);
			},
			// 校验车牌号重复
			checkCarNumber(val, index) {
				if (index == 0) {
					var postData = {
						SALTB416CA00: val, //车牌号
					}
				} else if (index == 1) {
					var postData = {
						SALTB416CA00: val, //车牌号
					}
				}
				var url = "/sal/saltb416/checkSaltb416ca00";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.result == 2) {
						if (index == 0) {
							this.postAdd();
						} else if (index == 1) {
							this.modifyPost()
						}
					} else {
						if (val == this.judgeCarNumMo) {
							if (index == 0) {
								this.postAdd();
							} else if (index == 1) {
								this.modifyPost()
							}
						} else {
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
					}
				})
			},
			// 新增取消--X
			XAdd() {
				this.materielIndex = 0;
			},
			// 新增取消
			cancelAdd() {
				this.billOperationAdd = false;
				// this.materielIndex = 0;
			},
			// 新增
			newlyAdd() {
				this.billOperationAdd = true;
				this.judgeAdd = 0;
				this.carNumberAdd = ''; //车牌号
				this.carNameAdd = ''; //姓名
				this.carPhoneAdd = ''; //电话
				this.tareIptAdd = ''
			},

			// 修改保存
			preservationModify() {
				
				if (this.carNameModify=='') {
					this.$message({
						message: '请选择物料类型',
						type: 'error'
					});
					return;

				}
				// this.checkCarNumber(this.carNumberModify, this.judgeModify);
				this.modifyPost()
			},
			modifyPost() {
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				if (this.userobj.pertb005.pertb005cb00 == 'CUS-1') {
					var ORMTB400ID = this.userobj.ormtb400.ORMTB400ID
				} else if (this.userobj.pertb005.pertb005cb00 == 'CUS-2') {
					var ORMTB400ID = this.userobj.ormtb410.ORMTB410ID
				}
				var postData = {
					SETTB109ID: this.wlnameobj.SETTB109ID, 
					SETTB109CB00: this.carNameModify
				}
				var url = "/set/settb109/updateWlType";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					setTimeout(() => {
						loading.close()
					}, 300)
					if (res.data.code == 200) {
						this.billOperationDetails = false;
						this.$message({
							message: '成功',
							type: 'success'
						});
						this.pageList();

					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			// 修改取消
			cancelModify() {
				this.billOperationDetails = false;
			},
			// 修改
			wllbmodify(row) {
				console.log(row)
				this.billOperationDetails = true;
				this.wlnameobj = row;
				this.wllbFun()
				// this.carNumberModify = row['carNums'] //车牌号
				// this.judgeCarNumMo = row['carNums'] //车牌号--修改--判断
				// this.customerManagementList = row['phoneName'] //车主姓名

			},
			// 查询
			queryClick() {
				this.pageMo = 1
				this.pageList()
			},
			// 列表
			pageList() {
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				// if (this.userobj.pertb005.pertb005cb00 == 'CUS-1') {
				// 	var ORMTB400ID = this.userobj.ormtb400.ORMTB400ID
				// } else if (this.userobj.pertb005.pertb005cb00 == 'CUS-2') {
				// 	var ORMTB400ID = this.userobj.ormtb410.ORMTB410ID
				// }
				var postData = {
					SETTB99ID: this.enterpriseTwo, //厂家
					SETTB109CB00: this.materielMo, //物料
					STATUS: this.status,
					page: this.pageMo,
					limit: this.limitMo
				}


				var moList;
				var url = "/set/settb109/wlList";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					setTimeout(() => {
						loading.close()
					}, 300)
					if (res.data.code == 200) {
						this.tableData = res.data.data;

						this.pagingPageMo = res.data.count;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			handleSizeChange(val) {
				this.pageMo = 1
				this.limitMo = val;
				this.pageList();
			},
			// 点击页码
			handleCurrentChange(val) {
				this.pageMo = val;
				this.pageList();
			},
			wllbFun() {
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					SETTB206CD01: '1002', 
					SETTB205ID: '05'
				}
				var url = "/set/settb206/select206List";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					setTimeout(() => {
						loading.close()
					}, 300)
					if (res.data.code == 200) {
						console.log(res)
						
						this.customerManagementList = res.data.data

					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			clearNoNum(value) {
				value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
				value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
				value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
				value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
				if (value.indexOf(".") < 0 && value != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
					value = parseFloat(value);
				}
				return value;
			},

		}
	}
</script>

<style scoped>
	.carManagement {
		background: #f3f3f3;
	}

	.bcarManagement-table {
		padding: 30px 20px 0;
	}

	.test111:active {
		background-color: red !important;
	}

	/* 新增--列表宽度 */
	.billOperationRecord .systemCodePC-add-code-table-li-ipt {
		flex: 1.5;
	}

	.fontBlue {
		color: rgba(25, 159, 255, 1) !important;
	}

	.public_oparetionBlock_Menu .pulic_carNumber {
		margin-top: 6px;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		font-size: 14px;
		display: inline-block;
	}

	.billOperationRecord .public_oparetionBlock_Menu {
		height: 45px;
		align-items: center;
	}

	.billOperationRecord {
		background-color: #f3f3f3;
	}

	.billOperationRecord th,
	.billOperationRecord td {
		text-align: center !important;
	}

	/* 弹框 */
	.systemCodePC-add-code {
		padding: 0 20px;
	}
	.systemCodePC-pagesize {
		text-align: right;
		margin-top: 20px;
	}
</style>
<style>
	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 90px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.itemMsg {
		padding: 0 10px;
	}

	.demo-table-expand .item-lxxx .el-form-item__content {
		width: 500px;
	}
</style>
<style>
.system-settings-systemwl-admin-dialog {
	border: 1px solid rgba(207, 225, 245, 0.95);
	border-radius: 18px;
	background: #f8fbff;
	box-shadow: 0 24px 70px rgba(18, 52, 77, 0.22);
	overflow: hidden;
}

.system-settings-systemwl-admin-dialog .el-dialog__header {
	position: relative;
	height: auto;
	line-height: normal;
	padding: 18px 54px 16px 24px;
	vertical-align: middle;
	background: linear-gradient(135deg, #f5fbff 0%, #ffffff 48%, #eef8ff 100%);
	border-bottom: 1px solid rgba(219, 233, 247, 0.95);
	color: #17324d;
}

.system-settings-systemwl-admin-dialog .el-dialog__header::before {
	content: "";
	position: absolute;
	left: 0;
	top: 0;
	width: 5px;
	height: 100%;
	background: linear-gradient(180deg, #199fff 0%, #5ac8fa 100%);
}

.system-settings-systemwl-admin-dialog .el-dialog__title {
	font-size: 18px;
	font-weight: 700;
	color: #17324d !important;
	letter-spacing: .2px;
}

.system-settings-systemwl-admin-dialog .el-dialog__headerbtn {
	top: 13px;
	right: 18px;
	border-radius: 50%;
	background: rgba(25, 159, 255, 0.08);
	transition: background .2s ease, transform .2s ease;
}

.system-settings-systemwl-admin-dialog .el-dialog__headerbtn:hover {
	background: rgba(25, 159, 255, 0.16);
	transform: rotate(90deg);
}

.system-settings-systemwl-admin-dialog .el-dialog__headerbtn .el-dialog__close {
	vertical-align: middle;
	font-size: 18px;
	color: #55708b !important;
}

.system-settings-systemwl-admin-dialog .el-dialog__body {
	max-height: calc(90vh - 130px);
	padding: 22px 24px 24px;
	background: linear-gradient(180deg, #ffffff 0%, #f7fbff 100%);
	color: #31445a;
	overflow-y: auto;
}

.system-settings-systemwl-admin-dialog .systemCodePC-add-code {
	padding: 0;
}

.system-settings-systemwl-admin-dialog .systemCodePC-add-code-table {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.system-settings-systemwl-admin-dialog .systemCodePC-add-code-table-li {
	display: grid;
	grid-template-columns: 120px minmax(0, 1fr) 64px;
	align-items: center;
	gap: 10px;
	min-height: 46px;
	padding: 10px 12px;
	border: 1px solid rgba(220, 232, 245, 0.9);
	border-radius: 12px;
	background: rgba(255, 255, 255, 0.88);
	box-shadow: 0 6px 16px rgba(23, 77, 124, 0.05);
	box-sizing: border-box;
}

.system-settings-systemwl-admin-dialog .systemCodePC-add-code-table-li-name {
	color: #203a56;
	font-size: 14px;
	font-weight: 600;
	text-align: right;
}

.system-settings-systemwl-admin-dialog .systemCodePC-add-code-table-li-ipt {
	min-width: 0;
}

.system-settings-systemwl-admin-dialog .systemCodePC-add-code-table-li-ipt input,
.system-settings-systemwl-admin-dialog .systemCodePC-add-code-table-li-ipt .el-input__inner {
	width: 100%;
	height: 36px;
	line-height: 36px;
	padding: 0 12px;
	border: 1px solid #d7e5f3;
	border-radius: 9px;
	background: #fff;
	color: #1f3449;
	box-sizing: border-box;
	transition: border-color .18s ease, box-shadow .18s ease;
}

.system-settings-systemwl-admin-dialog .systemCodePC-add-code-table-li-ipt input:focus,
.system-settings-systemwl-admin-dialog .systemCodePC-add-code-table-li-ipt .el-input__inner:focus {
	border-color: #199fff;
	box-shadow: 0 0 0 3px rgba(25, 159, 255, 0.12);
	outline: none;
}

.system-settings-systemwl-admin-dialog .systemCodePC-add-code-table-li-ipt input:disabled {
	background: #f3f7fb;
	color: #7a8ca0;
}

.system-settings-systemwl-admin-dialog .systemCodePC-add-code-table-li-text {
	color: #ff6b6b;
	font-size: 12px;
	white-space: nowrap;
}

.system-settings-systemwl-admin-dialog .el-select,
.system-settings-systemwl-admin-dialog .el-date-editor.el-input,
.system-settings-systemwl-admin-dialog .el-date-editor.el-input__inner {
	width: 100%;
}

.system-settings-systemwl-admin-dialog .systemCodePC-add-code-btn {
	display: flex;
	justify-content: space-between;
	gap: 16px;
	margin: 22px 0 0;
	padding-top: 18px;
	border-top: 1px solid rgba(223, 235, 247, 0.9);
}

.system-settings-systemwl-admin-dialog .systemCodePC-add-code-btn .el-button {
	min-width: 96px;
	border-radius: 9px;
	margin-left: 0;
}

.system-settings-systemwl-admin-dialog .systemCodePC-add-code-btn .el-button--warning {
	order: 1;
}

.system-settings-systemwl-admin-dialog .systemCodePC-add-code-btn .el-button--primary {
	order: 2;
}

@media screen and (max-width: 768px) {
	.system-settings-systemwl-admin-dialog {
		width: calc(100vw - 24px) !important;
	}

	.system-settings-systemwl-admin-dialog .el-dialog__body {
		padding: 18px 16px 20px;
	}

	.system-settings-systemwl-admin-dialog .systemCodePC-add-code-table-li {
		grid-template-columns: 1fr;
		gap: 8px;
	}

	.system-settings-systemwl-admin-dialog .systemCodePC-add-code-table-li-name {
		text-align: left;
	}
}
</style>
